module.exports = __webpack_public_path__ + "img/124.f2bba8e3.jpg";